import { useState, useContext } from 'react';
import { UserContext } from '../context/UserContext';
import { canCreateEmployee as canCreateFromInfo } from '../components/EmployeeLimitBanner';

/**
 * 員工數量限制狀態（照 CRM useCustomerLimitCache）：從 EmployeeLimitBanner 的 localStorage 快取初始化，按鈕不會先亮再變灰
 */
export const useEmployeeLimitCache = () => {
  const userContext = useContext(UserContext);
  const { user } = userContext!;

  const readCache = () => {
    if (!user?.organizationId) return null;
    try {
      const cached = localStorage.getItem(`employee-limit-${user.organizationId}`);
      return cached ? JSON.parse(cached) : null;
    } catch {
      return null; // 快取讀取失敗，使用預設值
    }
  };

  // 還能新增員工（等於上限就不行；員工列表的新增按鈕用）
  const [canCreateEmployee, setCanCreateEmployee] = useState<boolean>(() => {
    const info = readCache();
    return info ? canCreateFromInfo(info) : true;
  });

  // EmployeeLimitBanner 刷新觸發器
  const [limitBannerRefreshTrigger, setLimitBannerRefreshTrigger] = useState(0);

  return {
    canCreateEmployee,
    setCanCreateEmployee,
    limitBannerRefreshTrigger,
    setLimitBannerRefreshTrigger,
  };
};
